function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.98179 8.57801C5.43179 6.68401 5.87279 4.78901 6.33879 2.89901C6.64779 1.65001 7.15379 1.30601 8.37779 1.59901C10.9078 2.20401 13.4288 2.84601 15.9478 3.49701C17.0168 3.77401 17.3778 4.38201 17.1258 5.46601C16.2028 9.39001 15.2688 13.308 14.3208 17.225C14.0708 18.26 13.4828 18.642 12.4688 18.397C9.84479 17.765 7.22479 17.103 4.61079 16.425C3.63779 16.173 3.33279 15.57 3.58679 14.458C4.03479 12.495 4.51479 10.538 4.98179 8.57801Z",
  fill: "#B0B000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.28007 12.6102C8.73107 10.7162 9.17107 8.81917 9.63707 6.93017C9.94607 5.68117 10.4521 5.33617 11.6761 5.63017C14.2051 6.23517 16.7271 6.87717 19.2441 7.52917C20.3131 7.80617 20.6771 8.41217 20.4211 9.49917C19.5011 13.4222 18.5661 17.3402 17.6171 21.2572C17.3671 22.2922 16.7811 22.6742 15.7661 22.4282C13.1411 21.7962 10.5221 21.1352 7.90607 20.4572C6.93507 20.2052 6.62907 19.6032 6.88307 18.4902C7.33307 16.5262 7.81307 14.5692 8.28007 12.6102Z",
  fill: "#F5F500"
});

var SvgYellowCards = function SvgYellowCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowCards.c7a9be7f.svg";
export { ForwardRef as ReactComponent };